function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { _ } from '../../../../../lib/locale/translate';
import RegisterModal from '../register/RegisterModal';
function EyeIcon(_ref) {
  var {
    isOpen
  } = _ref;
  if (isOpen) {
    return /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "23",
      height: "19",
      viewBox: "0 0 23 19",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M4.30499 0.25228C4.23913 0.178036 4.15918 0.117603 4.06979 0.0744831C3.9804 0.0313634 3.88334 0.00641467 3.78423 0.00108303C3.68513 -0.00424861 3.58595 0.0101427 3.49245 0.0434231C3.39895 0.0767035 3.31298 0.128211 3.23953 0.19496C3.16608 0.261709 3.10661 0.342373 3.06457 0.432275C3.02252 0.522177 2.99874 0.61953 2.9946 0.718692C2.99045 0.817853 3.00603 0.916851 3.04043 1.00995C3.07483 1.10304 3.12737 1.18839 3.19499 1.26103L4.99874 3.24572C1.59374 5.33541 0.129366 8.55665 0.0646785 8.7029C0.0220346 8.79882 0 8.90262 0 9.00759C0 9.11256 0.0220346 9.21636 0.0646785 9.31228C0.097491 9.38634 0.891554 11.147 2.65687 12.9123C5.00905 15.2635 7.97999 16.5067 11.25 16.5067C12.9306 16.5162 14.5942 16.1702 16.1316 15.4913L18.1941 17.761C18.2599 17.8353 18.3399 17.8957 18.4293 17.9388C18.5186 17.9819 18.6157 18.0069 18.7148 18.0122C18.8139 18.0176 18.9131 18.0032 19.0066 17.9699C19.1001 17.9366 19.1861 17.8851 19.2595 17.8183C19.333 17.7516 19.3924 17.6709 19.4345 17.581C19.4765 17.4911 19.5003 17.3938 19.5044 17.2946C19.5086 17.1955 19.493 17.0965 19.4586 17.0034C19.4242 16.9103 19.3717 16.8249 19.3041 16.7523L4.30499 0.25228ZM8.74218 7.36228L12.6487 11.6607C12.0605 11.9702 11.386 12.0755 10.7314 11.9602C10.0768 11.8448 9.47896 11.5153 9.03189 11.0234C8.58481 10.5315 8.31377 9.90501 8.26134 9.24236C8.2089 8.5797 8.37803 7.91839 8.74218 7.36228ZM11.25 15.0067C8.36437 15.0067 5.84343 13.9576 3.75655 11.8895C2.89997 11.0382 2.17145 10.0671 1.59374 9.00665C2.03343 8.18259 3.43687 5.87634 6.0328 4.37728L7.7203 6.22884C7.06699 7.06557 6.73052 8.10631 6.77036 9.16713C6.81021 10.2279 7.22379 11.2405 7.93802 12.0259C8.65225 12.8112 9.62114 13.3188 10.6734 13.4589C11.7257 13.599 12.7936 13.3625 13.6884 12.7913L15.0694 14.3101C13.8506 14.7777 12.5553 15.0139 11.25 15.0067ZM11.8125 6.06009C11.6171 6.0228 11.4444 5.90939 11.3326 5.74483C11.2208 5.58027 11.1789 5.37802 11.2162 5.18259C11.2535 4.98716 11.3669 4.81455 11.5315 4.70273C11.6961 4.59091 11.8983 4.54905 12.0937 4.58634C13.0496 4.77166 13.92 5.26101 14.575 5.98142C15.23 6.70183 15.6346 7.61469 15.7284 8.58384C15.7469 8.78188 15.686 8.97917 15.5591 9.1323C15.4322 9.28544 15.2496 9.38188 15.0516 9.4004C15.0281 9.40178 15.0047 9.40178 14.9812 9.4004C14.7938 9.40121 14.6128 9.33178 14.474 9.20581C14.3352 9.07983 14.2486 8.90643 14.2312 8.71978C14.1681 8.07515 13.8986 7.46811 13.4628 6.98891C13.0271 6.50972 12.4482 6.18397 11.8125 6.06009ZM22.4325 9.31228C22.3931 9.4004 21.4434 11.5032 19.305 13.4185C19.2319 13.4861 19.1461 13.5384 19.0527 13.5724C18.9592 13.6065 18.8599 13.6216 18.7605 13.6169C18.6611 13.6122 18.5636 13.5878 18.4738 13.545C18.3839 13.5023 18.3035 13.4421 18.2371 13.368C18.1708 13.2938 18.1198 13.2072 18.0873 13.1132C18.0547 13.0192 18.0412 12.9196 18.0475 12.8203C18.0537 12.721 18.0797 12.624 18.1239 12.5348C18.168 12.4457 18.2295 12.3662 18.3047 12.301C19.3538 11.3585 20.2351 10.2445 20.9109 9.00665C20.3319 7.94519 19.6018 6.97348 18.7434 6.12197C16.6566 4.05572 14.1356 3.00665 11.25 3.00665C10.642 3.00591 10.0349 3.05514 9.43499 3.15384C9.33743 3.1711 9.23741 3.16885 9.14073 3.14723C9.04404 3.12561 8.95259 3.08505 8.87167 3.02788C8.79074 2.97072 8.72195 2.89809 8.66925 2.81419C8.61656 2.73029 8.58101 2.63678 8.56466 2.53906C8.54832 2.44134 8.55149 2.34135 8.57401 2.24487C8.59652 2.14838 8.63793 2.05731 8.69584 1.97692C8.75375 1.89653 8.82702 1.82842 8.9114 1.7765C8.99579 1.72459 9.08963 1.68991 9.18749 1.67447C9.86921 1.56191 10.559 1.50578 11.25 1.50665C14.52 1.50665 17.4909 2.74978 19.8431 5.10197C21.6084 6.86728 22.4025 8.62884 22.4353 8.7029C22.4779 8.79882 22.5 8.90262 22.5 9.00759C22.5 9.11256 22.4779 9.21636 22.4353 9.31228H22.4325Z",
      fill: "black"
    }));
  }
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1853 11.6962C23.1525 11.6222 22.3584 9.86062 20.5931 8.09531C18.2409 5.74312 15.27 4.5 12 4.5C8.72999 4.5 5.75905 5.74312 3.40687 8.09531C1.64155 9.86062 0.843741 11.625 0.814679 11.6962C0.772035 11.7922 0.75 11.896 0.75 12.0009C0.75 12.1059 0.772035 12.2097 0.814679 12.3056C0.847491 12.3797 1.64155 14.1403 3.40687 15.9056C5.75905 18.2569 8.72999 19.5 12 19.5C15.27 19.5 18.2409 18.2569 20.5931 15.9056C22.3584 14.1403 23.1525 12.3797 23.1853 12.3056C23.2279 12.2097 23.25 12.1059 23.25 12.0009C23.25 11.896 23.2279 11.7922 23.1853 11.6962ZM12 18C9.11437 18 6.59343 16.9509 4.50655 14.8828C3.65028 14.0313 2.92179 13.0603 2.34374 12C2.92164 10.9396 3.65014 9.9686 4.50655 9.11719C6.59343 7.04906 9.11437 6 12 6C14.8856 6 17.4066 7.04906 19.4934 9.11719C20.3514 9.9684 21.0815 10.9394 21.6609 12C20.985 13.2619 18.0403 18 12 18ZM12 7.5C11.11 7.5 10.2399 7.76392 9.49993 8.25839C8.7599 8.75285 8.18313 9.45566 7.84253 10.2779C7.50194 11.1002 7.41282 12.005 7.58646 12.8779C7.76009 13.7508 8.18867 14.5526 8.81801 15.182C9.44735 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0242 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4944C9.83993 14.1648 9.45542 13.6962 9.22835 13.1481C9.00129 12.5999 8.94188 11.9967 9.05764 11.4147C9.17339 10.8328 9.45911 10.2982 9.87867 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.148 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.824 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z",
    fill: "black"
  }));
}
EyeIcon.propTypes = {
  isOpen: PropTypes.bool.isRequired
};
var CHECK_PHONE_API = '/api/check-phone';
export default function ForgotPasswordModal(_ref2) {
  var {
    open,
    onClose: _onClose,
    onOpenLogin: _onOpenLogin,
    generateOtpApi,
    verifyOtpApi,
    resetPasswordApi,
    updatePasswordApi,
    createCustomerApi
  } = _ref2;
  var [step, setStep] = React.useState(1); // 1: phone, 2: new password, 3: confirmation
  var [phoneNumber, setPhoneNumber] = React.useState('');
  var [errors, setErrors] = React.useState({});
  var [registerModalOpen, setRegisterModalOpen] = React.useState(false);
  var [showOtpInput, setShowOtpInput] = React.useState(false);
  var [otpDigits, setOtpDigits] = React.useState(['', '', '', '']);
  var [otpVerified, setOtpVerified] = React.useState(false);
  var [otpWrong, setOtpWrong] = React.useState(false);
  var [countdown, setCountdown] = React.useState(299); // 4:59
  var [password, setPassword] = React.useState('');
  var [showPassword, setShowPassword] = React.useState(false);
  var [redirectCountdown, setRedirectCountdown] = React.useState(5);
  var [isSubmitting, setIsSubmitting] = React.useState(false);
  var [submitError, setSubmitError] = React.useState('');
  var [isVerifyingOtp, setIsVerifyingOtp] = React.useState(false);
  var [resetToken, setResetToken] = React.useState('');
  var otpRefs = React.useRef([]);
  React.useEffect(() => {
    if (!open) {
      // Reset state when modal closes
      setStep(1);
      setPhoneNumber('');
      setErrors({});
      setRegisterModalOpen(false);
      setShowOtpInput(false);
      setOtpDigits(['', '', '', '']);
      setOtpVerified(false);
      setOtpWrong(false);
      setCountdown(299);
      setPassword('');
      setShowPassword(false);
      setRedirectCountdown(5);
      setIsSubmitting(false);
      setSubmitError('');
      setIsVerifyingOtp(false);
      setResetToken('');
      return undefined;
    }
    var onKeyDown = e => {
      if (e.key === 'Escape') _onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, _onClose]);

  // Countdown timer for OTP
  React.useEffect(() => {
    if (showOtpInput && !otpVerified && countdown > 0) {
      var timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [showOtpInput, countdown, otpVerified]);

  // Redirect countdown and navigation
  React.useEffect(() => {
    if (step === 3 && redirectCountdown > 0) {
      var timer = setTimeout(() => setRedirectCountdown(redirectCountdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (step === 3 && redirectCountdown === 0) {
      // Close forgot password modal and open login modal
      if (_onOpenLogin) {
        _onOpenLogin();
      }
    }
    return undefined;
  }, [step, redirectCountdown, _onClose, _onOpenLogin]);
  var validatePhoneNumber = phone => {
    var normalized = phone.replace(/\s+/g, '');
    var nextErrors = {};
    if (!normalized) {
      nextErrors.phoneNumber = _('Phone number is required');
    } else if (!/^\d+$/.test(normalized)) {
      nextErrors.phoneNumber = _('Phone number must contain only digits');
    } else if (normalized.length !== 11) {
      nextErrors.phoneNumber = _('Phone number must be exactly 11 digits');
    } else if (!['010', '011', '012', '015'].some(prefix => normalized.startsWith(prefix))) {
      nextErrors.phoneNumber = _('Phone number must start with 010 011 012 or 015');
    }
    return nextErrors;
  };
  var isFormValid = () => {
    var normalized = phoneNumber.replace(/\s+/g, '');
    if (!normalized) return false;
    if (!/^\d+$/.test(normalized)) return false;
    if (normalized.length !== 11) return false;
    if (!['010', '011', '012', '015'].some(prefix => normalized.startsWith(prefix))) {
      return false;
    }
    if (showOtpInput && !otpVerified && otpDigits.some(d => !d)) return false;
    return true;
  };
  var handlePhoneChange = e => {
    var value = e.target.value.replace(/\D/g, ''); // Only digits
    if (value.length <= 11) {
      setPhoneNumber(value);
    }
  };
  var handleOtpChange = (index, value) => {
    var digit = value.replace(/\D/g, '').slice(-1); // Only last digit
    var newOtpDigits = [...otpDigits];
    newOtpDigits[index] = digit;
    setOtpDigits(newOtpDigits);

    // Reset wrong state when user types
    if (otpWrong) {
      setOtpWrong(false);
    }

    // Auto-focus next input
    if (digit && index < 3) {
      var _otpRefs$current;
      (_otpRefs$current = otpRefs.current[index + 1]) === null || _otpRefs$current === void 0 || _otpRefs$current.focus();
    }

    // Check if all 4 digits are filled
    if (newOtpDigits.every(d => d) && !isVerifyingOtp) {
      verifyOtpAndContinue(newOtpDigits.join(''));
    }
  };
  var requestOtp = async () => {
    var normalizedPhone = phoneNumber.replace(/\s+/g, '');
    setSubmitError('');
    setIsSubmitting(true);
    try {
      var _checkPhoneResponseJs2;
      var checkPhoneResponse = await fetch(CHECK_PHONE_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumber: normalizedPhone
        })
      });
      var checkPhoneResponseJson = await checkPhoneResponse.json();
      if (!checkPhoneResponse.ok || checkPhoneResponseJson.error) {
        var _checkPhoneResponseJs;
        setSubmitError(((_checkPhoneResponseJs = checkPhoneResponseJson.error) === null || _checkPhoneResponseJs === void 0 ? void 0 : _checkPhoneResponseJs.message) || _('Failed to validate phone number'));
        return false;
      }
      if (!(checkPhoneResponseJson !== null && checkPhoneResponseJson !== void 0 && (_checkPhoneResponseJs2 = checkPhoneResponseJson.data) !== null && _checkPhoneResponseJs2 !== void 0 && _checkPhoneResponseJs2.exists)) {
        setSubmitError(_('Phone number does not exist'));
        return false;
      }
      var response = await fetch(generateOtpApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumber: normalizedPhone
        })
      });
      var responseJson = await response.json();
      if (!response.ok || responseJson.error) {
        var _responseJson$error;
        setSubmitError(((_responseJson$error = responseJson.error) === null || _responseJson$error === void 0 ? void 0 : _responseJson$error.message) || _('Failed to send OTP'));
        return false;
      }
      setShowOtpInput(true);
      setCountdown(299);
      setOtpDigits(['', '', '', '']);
      setOtpVerified(false);
      setOtpWrong(false);
      return true;
    } catch (error) {
      setSubmitError(_('Something went wrong. Please try again.'));
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };
  var verifyOtpAndContinue = async otpCode => {
    var normalizedPhone = phoneNumber.replace(/\s+/g, '');
    setSubmitError('');
    setIsVerifyingOtp(true);
    try {
      var _resetResponseJson$da;
      var verifyResponse = await fetch(verifyOtpApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumber: normalizedPhone,
          otp: otpCode
        })
      });
      var verifyResponseJson = await verifyResponse.json();
      if (!verifyResponse.ok || verifyResponseJson.error) {
        var _verifyResponseJson$e;
        setOtpVerified(false);
        setOtpWrong(true);
        setSubmitError(((_verifyResponseJson$e = verifyResponseJson.error) === null || _verifyResponseJson$e === void 0 ? void 0 : _verifyResponseJson$e.message) || _('OTP verification failed'));
        return;
      }
      var resetResponse = await fetch(resetPasswordApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumber: normalizedPhone
        })
      });
      var resetResponseJson = await resetResponse.json();
      if (!resetResponse.ok || resetResponseJson.error) {
        var _resetResponseJson$er;
        setSubmitError(((_resetResponseJson$er = resetResponseJson.error) === null || _resetResponseJson$er === void 0 ? void 0 : _resetResponseJson$er.message) || _('Failed to continue password reset'));
        return;
      }
      var token = (resetResponseJson === null || resetResponseJson === void 0 || (_resetResponseJson$da = resetResponseJson.data) === null || _resetResponseJson$da === void 0 ? void 0 : _resetResponseJson$da.token) || (resetResponseJson === null || resetResponseJson === void 0 ? void 0 : resetResponseJson.token) || '';
      if (!token) {
        setSubmitError(_('Failed to prepare password update'));
        return;
      }
      setResetToken(token);
      setOtpVerified(true);
      setOtpWrong(false);
      setTimeout(() => {
        setStep(2);
      }, 600);
    } catch (error) {
      setOtpVerified(false);
      setOtpWrong(true);
      setSubmitError(_('Something went wrong. Please try again.'));
    } finally {
      setIsVerifyingOtp(false);
    }
  };
  var handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpDigits[index] && index > 0) {
      var _otpRefs$current2;
      (_otpRefs$current2 = otpRefs.current[index - 1]) === null || _otpRefs$current2 === void 0 || _otpRefs$current2.focus();
    }
  };
  var formatTime = seconds => {
    var mins = Math.floor(seconds / 60);
    var secs = seconds % 60;
    return "".concat(mins, ":").concat(secs.toString().padStart(2, '0'));
  };
  var PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>\-+_~;[\]=/]/;
  var getPasswordValidationChecks = () => [{
    text: _('At least 8 characters'),
    valid: password && password.length >= 8
  }, {
    text: _('At least one uppercase letter'),
    valid: password && /[A-Z]/.test(password)
  }, {
    text: _('At least one lowercase letter'),
    valid: password && /[a-z]/.test(password)
  }, {
    text: _('At least one number'),
    valid: password && /[0-9]/.test(password)
  }, {
    text: _('At least one special character'),
    valid: password && PASSWORD_SPECIAL_CHAR_REGEX.test(password)
  }];
  var isPasswordValid = () => {
    if (!password) return false;
    if (password.length < 8) return false;
    if (!/[A-Z]/.test(password)) return false;
    if (!/[a-z]/.test(password)) return false;
    if (!/[0-9]/.test(password)) return false;
    if (!PASSWORD_SPECIAL_CHAR_REGEX.test(password)) return false;
    return true;
  };
  var getOtpInputBorder = digit => {
    if (!digit) {
      return 'none';
    }
    if (otpVerified) {
      return '2px solid #4CAF50';
    }
    if (otpWrong) {
      return '2px solid #CF221E';
    }
    return '2px solid black';
  };
  var getVerifyButtonClass = () => {
    if (otpVerified) {
      return 'bg-[#4CAF50] hover:opacity-95';
    }
    if (otpWrong) {
      return 'bg-[#CF221E] disabled:bg-[#CF221E] disabled:cursor-not-allowed disabled:hover:opacity-100';
    }
    return 'bg-black hover:opacity-95 disabled:bg-[#717171] disabled:cursor-not-allowed disabled:hover:opacity-100';
  };
  var getVerifyButtonText = () => {
    if (otpVerified) {
      return _('VERIFIED');
    }
    if (otpWrong) {
      return _('NOT VERIFIED');
    }
    return _('VERIFY');
  };
  var onSubmit = async e => {
    e.preventDefault();
    if (step === 1) {
      var nextErrors = validatePhoneNumber(phoneNumber);
      setErrors(nextErrors);
      if (Object.keys(nextErrors).length > 0) return;
      if (!showOtpInput) {
        requestOtp();
      } else if (otpVerified) {
        // Move to password reset step
        setStep(2);
      }
    } else if (step === 2) {
      // Validate password
      if (!isPasswordValid()) {
        setErrors({
          password: _('Please meet all password requirements')
        });
        return;
      }
      if (!resetToken) {
        setSubmitError(_('Reset token is missing. Please request OTP again.'));
        setStep(1);
        setShowOtpInput(false);
        setOtpDigits(['', '', '', '']);
        setOtpVerified(false);
        return;
      }
      setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
        password: undefined
      }));
      setSubmitError('');
      setIsSubmitting(true);
      try {
        var updateResponse = await fetch(updatePasswordApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: resetToken,
            password
          })
        });
        var updateResponseJson = await updateResponse.json();
        if (!updateResponse.ok || updateResponseJson.error) {
          var _updateResponseJson$e;
          setSubmitError(((_updateResponseJson$e = updateResponseJson.error) === null || _updateResponseJson$e === void 0 ? void 0 : _updateResponseJson$e.message) || _('Failed to update password. Please try again.'));
          return;
        }
        setStep(3);
        setRedirectCountdown(5);
      } catch (error) {
        setSubmitError(_('Something went wrong. Please try again.'));
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  return /*#__PURE__*/React.createElement(AnimatePresence, null, open && !registerModalOpen && /*#__PURE__*/React.createElement(motion.div, {
    className: "fixed inset-0 z-[200] flex items-center justify-center !m-0",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.2,
      ease: 'easeOut'
    },
    role: "dialog",
    "aria-modal": "true",
    "aria-label": _('Forgot Password')
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: "absolute inset-0 bg-black/40"
  }), /*#__PURE__*/React.createElement(motion.div, {
    className: "relative z-[1] w-[90vw] max-w-[640px] rounded-[11.28px] bg-[#F7F7F7] p-[24px]",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.2,
      ease: 'easeOut'
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[24px] font-[500] mt-[6px] text-black uppercase tracking-[-1.3px]"
  }, _('FORGOT PASSWORD')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": _('Close'),
    onClick: _onClose,
    className: "text-[#C60910] hover:opacity-80 transition-opacity"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 16.2151C17.3431 16.2848 17.3983 16.3675 17.436 16.4586C17.4738 16.5496 17.4932 16.6472 17.4932 16.7457C17.4932 16.8443 17.4738 16.9418 17.436 17.0329C17.3983 17.1239 17.3431 17.2066 17.2734 17.2763C17.2037 17.346 17.121 17.4013 17.0299 17.439C16.9389 17.4767 16.8413 17.4961 16.7428 17.4961C16.6442 17.4961 16.5467 17.4767 16.4556 17.439C16.3646 17.4013 16.2819 17.346 16.2122 17.2763L9.99316 11.0563L3.77413 17.2763C3.63341 17.417 3.44255 17.4961 3.24354 17.4961C3.04453 17.4961 2.85367 17.417 2.71294 17.2763C2.57222 17.1356 2.49316 16.9447 2.49316 16.7457C2.49316 16.5467 2.57222 16.3558 2.71294 16.2151L8.93291 9.99609L2.71294 3.77706C2.57222 3.63634 2.49316 3.44548 2.49316 3.24647C2.49316 3.04746 2.57222 2.8566 2.71294 2.71587C2.85367 2.57515 3.04453 2.49609 3.24354 2.49609C3.44255 2.49609 3.63341 2.57515 3.77413 2.71587L9.99316 8.93584L16.2122 2.71587C16.3529 2.57515 16.5438 2.49609 16.7428 2.49609C16.9418 2.49609 17.1327 2.57515 17.2734 2.71587C17.4141 2.8566 17.4932 3.04746 17.4932 3.24647C17.4932 3.44548 17.4141 3.63634 17.2734 3.77706L11.0534 9.99609L17.2734 16.2151Z",
    fill: "#C60910"
  })))), step === 1 && /*#__PURE__*/React.createElement("form", {
    className: "mt-4",
    onSubmit: onSubmit,
    noValidate: true
  }, submitError && /*#__PURE__*/React.createElement("div", {
    className: "mb-3 text-[12px] text-[#C60910]"
  }, submitError), !showOtpInput ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "forgot_phoneNumber",
    className: "block text-[16px] font-rubik font-[400] text-black"
  }, _('Phone number')), /*#__PURE__*/React.createElement("input", {
    id: "forgot_phoneNumber",
    name: "phoneNumber",
    type: "tel",
    inputMode: "tel",
    autoComplete: "tel",
    value: phoneNumber,
    onChange: handlePhoneChange,
    className: "!mt-[8px] w-full rounded-[8px] !bg-[#DBD9D938] !p-3 text-[16px] font-rubik font-[400px] text-black outline-none ring-0 focus:!bg-[#FFFFFF] focus:ring-1 focus:ring-black transition-all ease-in-out rtl:text-right",
    placeholder: _('010919292736')
  }), errors.phoneNumber && /*#__PURE__*/React.createElement("div", {
    className: "mt-2 text-[12px] text-[#C60910]"
  }, errors.phoneNumber)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: !isFormValid() || isSubmitting,
    className: "mt-6 h-[50px] w-full rounded-[8px] bg-black !text-[20px] !font-[500] uppercase tracking-wide text-white hover:opacity-95 transition-opacity disabled:bg-[#717171] disabled:cursor-not-allowed disabled:hover:opacity-100"
  }, isSubmitting ? _('LOADING...') : _('Confirm'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[16px] font-rubik font-[400] text-black"
  }, _('Please enter the verification-code sent to')), /*#__PURE__*/React.createElement("p", {
    className: "text-[24px] font-[700] rtl:font-rubik text-black mt-1"
  }, phoneNumber), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      setShowOtpInput(false);
      setOtpDigits(['', '', '', '']);
      setOtpVerified(false);
    },
    className: "text-[16px] font-rubik font-[400] text-black hover:underline mt-1 bg-transparent border-0 p-0 cursor-pointer"
  }, _('Wrong number?'))), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 flex justify-center gap-[14px] rtl:flex-row-reverse"
  }, otpDigits.map((digit, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "w-[48px] h-[50px]"
  }, /*#__PURE__*/React.createElement("input", {
    ref: el => {
      otpRefs.current[index] = el;
    },
    type: "text",
    inputMode: "numeric",
    maxLength: "1",
    value: digit,
    onChange: e => handleOtpChange(index, e.target.value),
    onKeyDown: e => handleOtpKeyDown(index, e),
    disabled: otpVerified || countdown === 0,
    style: {
      border: getOtpInputBorder(digit)
    },
    className: "w-full h-full text-center text-[22px] font-inter font-[400] !bg-white text-black rounded-[8px] outline-none disabled:opacity-70 disabled:cursor-not-allowed"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-[24px] text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64712 6.07251L5.54712 8.17251C5.44861 8.27102 5.315 8.32636 5.17568 8.32636C5.03637 8.32636 4.90276 8.27102 4.80425 8.17251C4.70573 8.074 4.65039 7.94039 4.65039 7.80107C4.65039 7.66176 4.70573 7.52815 4.80425 7.42964L6.90424 5.32964C7.00276 5.23112 7.13637 5.17578 7.27568 5.17578C7.415 5.17578 7.54861 5.23112 7.64712 5.32964C7.74563 5.42815 7.80097 5.56176 7.80097 5.70107C7.80097 5.84039 7.74563 5.974 7.64712 6.07251ZM19.1971 7.42964L17.0971 5.32964C16.9986 5.23112 16.865 5.17578 16.7257 5.17578C16.5864 5.17578 16.4528 5.23112 16.3542 5.32964C16.2557 5.42815 16.2004 5.56176 16.2004 5.70107C16.2004 5.84039 16.2557 5.974 16.3542 6.07251L18.4542 8.17251C18.503 8.22129 18.5609 8.25998 18.6247 8.28638C18.6884 8.31278 18.7567 8.32636 18.8257 8.32636C18.8947 8.32636 18.963 8.31278 19.0267 8.28638C19.0904 8.25998 19.1483 8.22129 19.1971 8.17251C19.2459 8.12373 19.2846 8.06582 19.311 8.00209C19.3374 7.93836 19.351 7.87006 19.351 7.80107C19.351 7.73209 19.3374 7.66378 19.311 7.60005C19.2846 7.53632 19.2459 7.47841 19.1971 7.42964ZM18.3007 12.5261C18.3007 13.7721 17.9312 14.9901 17.2389 16.0262C16.5467 17.0622 15.5628 17.8697 14.4116 18.3465C13.2604 18.8233 11.9937 18.9481 10.7716 18.705C9.54953 18.4619 8.42698 17.8619 7.54591 16.9808C6.66484 16.0998 6.06482 14.9772 5.82174 13.7551C5.57865 12.5331 5.70341 11.2663 6.18024 10.1152C6.65707 8.96399 7.46456 7.98007 8.50059 7.28781C9.53662 6.59556 10.7547 6.22607 12.0007 6.22607C13.671 6.22798 15.2723 6.89235 16.4533 8.07341C17.6344 9.25448 18.2988 10.8558 18.3007 12.5261ZM16.2007 12.5261C16.2007 12.3868 16.1454 12.2533 16.0469 12.1548C15.9485 12.0564 15.8149 12.0011 15.6757 12.0011H12.5257V8.85107C12.5257 8.71183 12.4704 8.5783 12.3719 8.47984C12.2735 8.38139 12.1399 8.32607 12.0007 8.32607C11.8614 8.32607 11.7279 8.38139 11.6295 8.47984C11.531 8.5783 11.4757 8.71183 11.4757 8.85107V12.5261C11.4757 12.6653 11.531 12.7988 11.6295 12.8973C11.7279 12.9958 11.8614 13.0511 12.0007 13.0511H15.6757C15.8149 13.0511 15.9485 12.9958 16.0469 12.8973C16.1454 12.7988 16.2007 12.6653 16.2007 12.5261Z",
    fill: "#060708"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-[14px] font-rubik font-[400] text-black rtl:font-rubik"
  }, formatTime(countdown)), countdown === 0 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      requestOtp();
    },
    className: "text-[14px] font-rubik font-[600] text-black hover:underline bg-transparent border-0 p-0 cursor-pointer ml-1"
  }, _('Resend code.')))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: !otpVerified,
    className: "mt-4 h-[50px] w-full rounded-[8px] !text-[20px] !font-[500] uppercase tracking-wide text-white transition-opacity ".concat(getVerifyButtonClass())
  }, getVerifyButtonText()), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 text-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[16px] font-rubik font-[400] text-black"
  }, _("Didn't receive a code?"), ' '), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      requestOtp();
    },
    className: "text-[16px] font-rubik font-[500] text-black hover:underline bg-transparent border-0 p-0 cursor-pointer"
  }, _('Resend code.'))))), step === 2 && /*#__PURE__*/React.createElement("form", {
    className: "mt-4",
    onSubmit: onSubmit,
    noValidate: true
  }, submitError && /*#__PURE__*/React.createElement("div", {
    className: "mb-3 text-[12px] text-[#C60910]"
  }, submitError), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "reset_password",
    className: "block text-[16px] font-rubik font-[400] text-black"
  }, _('Password')), /*#__PURE__*/React.createElement("div", {
    className: "relative !mt-[8px]"
  }, /*#__PURE__*/React.createElement("input", {
    id: "reset_password",
    name: "password",
    type: showPassword ? 'text' : 'password',
    autoComplete: "new-password",
    value: password,
    onChange: e => setPassword(e.target.value),
    className: "w-full rounded-[8px] !bg-[#DBD9D938] !p-3 pr-12 text-[16px] font-rubik font-[400] text-black outline-none ring-0 focus:!bg-[#FFFFFF] focus:ring-1 focus:ring-black transition-all ease-in-out",
    placeholder: _('**************')
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": showPassword ? _('Hide password') : _('Show password'),
    onClick: () => setShowPassword(v => !v),
    className: "absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2 text-[#6B6B6B] hover:text-black transition-colors z-10"
  }, /*#__PURE__*/React.createElement(EyeIcon, {
    isOpen: showPassword
  }))), errors.password && /*#__PURE__*/React.createElement("div", {
    className: "mt-2 text-[12px] text-[#C60910]"
  }, errors.password)), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 space-y-2"
  }, getPasswordValidationChecks().map((check, idx) => /*#__PURE__*/React.createElement("div", {
    key: idx,
    className: "flex items-center gap-2"
  }, check.valid ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6796 16.7418L12.6712 19.5144C13.004 19.8228 13.5188 19.8207 13.8491 19.5095L22.1871 11.6536M6.66667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V6.66667C28 5.19391 26.8061 4 25.3333 4H6.66667C5.19391 4 4 5.19391 4 6.66667V25.3333C4 26.8061 5.19391 28 6.66667 28Z",
    stroke: "white",
    strokeWidth: "2.58788",
    strokeLinecap: "round"
  })) : /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "4",
    y: "4",
    width: "24",
    height: "24",
    rx: "2.66667",
    fill: "#DBD9D9",
    fillOpacity: "0.22"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-[12px] font-rubik text-black"
  }, check.text)))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: !isPasswordValid() || isSubmitting,
    className: "mt-6 h-[50px] w-full rounded-[8px] bg-black !text-[20px] !font-[500] uppercase tracking-wide text-white hover:opacity-95 transition-opacity disabled:bg-[#717171] disabled:cursor-not-allowed disabled:hover:opacity-100"
  }, isSubmitting ? _('LOADING...') : _('SUBMIT'))), step === 3 && /*#__PURE__*/React.createElement("div", {
    className: "mt-8 flex flex-col items-center"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "44",
    height: "44",
    rx: "22",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4656 15.8771L18.9656 32.3771C18.8219 32.5213 18.6511 32.6357 18.4631 32.7138C18.275 32.7918 18.0735 32.832 17.8699 32.832C17.6663 32.832 17.4647 32.7918 17.2767 32.7138C17.0886 32.6357 16.9179 32.5213 16.7742 32.3771L9.55542 25.1583C9.41153 25.0144 9.29739 24.8436 9.21952 24.6556C9.14164 24.4676 9.10156 24.2661 9.10156 24.0626C9.10156 23.8591 9.14164 23.6576 9.21952 23.4696C9.29739 23.2816 9.41153 23.1108 9.55542 22.9669C9.69931 22.823 9.87013 22.7089 10.0581 22.631C10.2461 22.5531 10.4476 22.513 10.6511 22.513C10.8546 22.513 11.0561 22.5531 11.2441 22.631C11.4321 22.7089 11.6029 22.823 11.7468 22.9669L17.8712 29.0912L33.2767 13.6882C33.5673 13.3976 33.9615 13.2344 34.3724 13.2344C34.7834 13.2344 35.1776 13.3976 35.4682 13.6882C35.7587 13.9788 35.922 14.373 35.922 14.7839C35.922 15.1949 35.7587 15.589 35.4682 15.8796L35.4656 15.8771Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("p", {
    className: "mt-6 text-[16px] font-rubik font-[400] text-black text-center"
  }, _('Your password has been reset successfully. Please log in with your new password.')), /*#__PURE__*/React.createElement("p", {
    className: "mt-3 text-[16px] font-rubik font-[500] text-black text-center"
  }, _('Almost there! Redirecting to login page in'), ' ', redirectCountdown, " ", _('seconds...'))), (step === 1 && !showOtpInput || step === 2) && /*#__PURE__*/React.createElement("div", {
    className: "mt-[16px] text-center text-[16px] font-rubik font-[400] text-black"
  }, _("Don't have an account?"), " ", /*#__PURE__*/React.createElement("br", {
    className: "md:hidden"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      setRegisterModalOpen(true);
    },
    className: "font-rubik font-[500] text-black hover:underline bg-transparent border-0 cursor-pointer"
  }, _('Create a new account.'))))), /*#__PURE__*/React.createElement(RegisterModal, {
    open: registerModalOpen,
    generateOtpApi: generateOtpApi,
    verifyOtpApi: verifyOtpApi,
    createCustomerApi: createCustomerApi,
    onClose: () => {
      setRegisterModalOpen(false);
      _onClose();
    },
    onOpenLogin: () => {
      setRegisterModalOpen(false);
      if (_onOpenLogin) {
        _onOpenLogin();
      }
    }
  }));
}
ForgotPasswordModal.propTypes = {
  generateOtpApi: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenLogin: PropTypes.func,
  createCustomerApi: PropTypes.string.isRequired,
  resetPasswordApi: PropTypes.string.isRequired,
  updatePasswordApi: PropTypes.string.isRequired,
  verifyOtpApi: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
};
ForgotPasswordModal.defaultProps = {
  onOpenLogin: null
};